import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";

const NewInvoice = () => {
  const [formData, setFormData] = useState({
    file_number: "",
    house_number: "",
    searchcolumns: "",
    search_value: "",
    b_name: "",
    phone_number: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  return (
    <DashboardLayout>
      <h2 className="m-4">New Invoice</h2>
      <form onSubmit={handleSubmit}>
        <div className="row m-4">
          <div className="col-lg-3 form-group">
            <label htmlFor="file_number" className="form-label fw-bolder">
              File#
            </label>
            <input
              type="text"
              name="file_number"
              id="file_number"
              className="form-control"
              value={formData.file_number}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-3 form-group">
            <label htmlFor="house_number" className="form-label fw-bolder">
              House#
            </label>
            <input
              type="text"
              name="house_number"
              id="house_number"
              className="form-control"
              value={formData.house_number}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-3 form-group">
            <label htmlFor="searchcolumns" className="form-label fw-bolder">
              Search By:
            </label>
            <select
              name="searchcolumns"
              id="searchcolumns"
              className="form-control"
              value={formData.searchcolumns}
              onChange={handleChange}
            >
              <option value="" selected="selected">
                -- Select --
              </option>
              <option value="ID">ID</option>
              <option value="cnic">CNIC</option>
            </select>
          </div>
          <div className="col-lg-3 form-group">
            <label htmlFor="search_value" className="form-label fw-bolder">
              Search:
            </label>
            <input
              type="text"
              name="search_value"
              id="search_value"
              value={formData.search_value}
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-3 form-group">
            <label htmlFor="b_name" className="form-label fw-bolder">
              Name
            </label>
            <input
              type="text"
              name="b_name"
              id="b_name"
              className="form-control"
              value={formData.b_name}
              onChange={handleChange}
            />
          </div>
          <div className="col-lg-3 form-group">
            <label htmlFor="phone_number" className="form-label fw-bolder">
              Contact#
            </label>
            <input
              type="text"
              name="phone_number"
              id="phone_number"
              className="form-control"
              value={formData.phone_number}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row mx-4">
          <div className="col-lg-2 form-group">
            <input
              type="submit"
              value="Search"
              className="btn site_btn text-white"
            />
          </div>
        </div>
      </form>
    </DashboardLayout>
  );
};

export default NewInvoice;
